import axios from 'axios'

export default {
  namespaced: true,
  state: {
    now: null,
    offers: null,
    heading: null,
  },
  mutations: {
    SET_NOW(state, date) {
      state.now = date
    },
    SET_OFFERS(state, offers) {
      state.offers = offers
    },
    SET_HEADING(state, { title, subtitle }) {
      state.heading = {
        title, subtitle,
      }
    },
  },
  actions: {
    async INIT_OFFERS({ dispatch }) {
      const offers = await dispatch('GET_OFFERS')
      if (!offers || !offers.length) {
        return
      }
      dispatch('START_UPDATING_DATE')
    },
    async GET_OFFERS({ rootState, commit }) {
      const res = await axios(`${rootState.api}/adapted-offers`)
      if (!res.data || !res.data.data || !res.data.data.items) {
        return
      }
      const heading = { title: res.data.data.title, subtitle: res.data.data.subtitle }
      commit('SET_HEADING', heading)
      commit('SET_OFFERS', res.data.data.items)
      return res.data.data
    },
    START_UPDATING_DATE({ commit, state }) {
      if (state.now) {
        return
      }

      setInterval(() => commit('SET_NOW', new Date()), 1000)
    },
  },

}
